<template>
  <div class="formulario h2-defaultMuni" @keyup.enter="aplicarFiltro">
    <div class="input-wrapper">
      <PickadayComponent v-model="fechasSeleccionadas" />
      <span v-if="fechasSeleccionadas.length > 0" @click="fechasSeleccionadas = []" class="clear-button">&times;</span>
    </div>

    <div class="input-wrapper">
      <SearchableSelect :options="areas" :disabledItems="[area]" :filter-keys="['area_name']" :selected="area"
        :useLastAsPlaceholder="true" placeholderKey="area_name" defaultPlaceholder="Áreas" @select="(v) => area = v"
        :overlayDropdown="true">
        <template #default="{ option }">
          <div class="status-item-container">
            <span class="h3-heroMuni">{{ option.area_name }}</span>
          </div>
        </template>
      </SearchableSelect>
      <span v-if="area" @click="area = null" class="clear-button">&times;</span>
    </div>

    <div class="btnsSection">
      <button @click="aplicarFiltro" class="actionBtn h2-heroMuni"
        style="background-color: var(--color-success)">Aplicar</button>
      <button @click="limpiarFiltro" class="actionBtn h2-heroMuni"
        style="background-color: var(--color-error)">Limpiar</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import PickadayComponent from "@/components/Utils/PickadayComponent.vue";
// import SearchableSelect from "@/components/Utils/SearchableSelect.vue";
import { useRouter } from "vue-router";
import { SearchableSelect } from "procedures-engine";

const props = defineProps({
  areas: { type: Array, default: () => [] }
});
const emit = defineEmits(["close-modal"]);
const store = useStore();
const router = useRouter();

const fechasSeleccionadas = ref([]);
const area = ref(null);

const loadFiltersFromStore = () => {
  const filters = store.state.filters['turnero'] || {}; // El store key es 'turnero'
  fechasSeleccionadas.value = [];
  if (filters.fromDate) fechasSeleccionadas.value[0] = filters.fromDate;
  if (filters.toDate) fechasSeleccionadas.value[1] = filters.toDate;

  area.value = filters.area
    ? (props.areas?.find((c) => c.area_name === filters.area) ?? null)
    : null;
};

onMounted(() => loadFiltersFromStore());

function aplicarFiltro() {
  const condiciones = {};
  if (fechasSeleccionadas.value[0]) condiciones.fromDate = fechasSeleccionadas.value[0];
  if (fechasSeleccionadas.value[1]) condiciones.toDate = fechasSeleccionadas.value[1];
  if (area.value) condiciones.area = area.value.area_name;

  if (Object.keys(condiciones).length === 0) return;

  if (document.activeElement) {
    document.activeElement.blur(); //quita foco del input
  }
  store.dispatch("setFiltersAction", { seccion: 'turnero', condiciones });
  router.push({ name: "turnero" });
  emit("close-modal");
}

function limpiarFiltro() {
  fechasSeleccionadas.value = [];
  area.value = null;
  store.dispatch("clearFiltersAction", 'turnero');
  emit("close-modal");
}

watch(
  [() => props],
  () => {
    loadFiltersFromStore();
  },
  { deep: true }
);
</script>